import { render, staticRenderFns } from "./RiwayatPengiriman.vue?vue&type=template&id=1478cfd8&scoped=true&"
import script from "./RiwayatPengiriman.vue?vue&type=script&lang=js&"
export * from "./RiwayatPengiriman.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatPengiriman.vue?vue&type=style&index=0&id=1478cfd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478cfd8",
  null
  
)

export default component.exports